import {createAsyncThunk, createSlice, current} from '@reduxjs/toolkit';
import {
    deleteTripByIdApi,
    getAllTripApi,
    getAllTripsByOperatorApi, getAllTripTimesByOperatorApi,
    getTripByIdApi,
    postTripApi,
    putTripApi
} from "../../api/backendAPIs";
import moment from "moment/moment";

export const fetchAllDepartures = createAsyncThunk('fetchAllDepartures', async (payload) => {
    return await getAllTripApi(payload)
})

export const fetchAllDeparturesByOperator = createAsyncThunk('fetchAllDeparturesByOperator', async (payload) => {
    return await getAllTripsByOperatorApi(payload)
})

export const getAllTripTimesByOperator = createAsyncThunk('getAllTripTimesByOperator', async (payload) => {
    return await getAllTripTimesByOperatorApi(payload)
})

export const deleteDepartureById = createAsyncThunk('deleteDepartureById', async (payload) => {
    return deleteTripByIdApi(payload);
})

export const postDeparture = createAsyncThunk('postDeparture', async (payload) => {
    return postTripApi(payload);
})

export const getDepartureById = createAsyncThunk('getDepartureById', async (payload) => {
    return getTripByIdApi(payload);
})

export const updateDeparture = createAsyncThunk('updateDeparture', async (payload) => {
    return putTripApi(payload);
})

const initialState = {
    departures: [],
    tripTimes: [],
    departure: null,
    loadingDepartures: false
}

export const departureSlice = createSlice({
    name: 'departures',
    initialState,
    reducers: {},
    extraReducers: {
        [fetchAllDepartures.pending]: (state) => {
            state.loadingTrips = true;
        },
        [fetchAllDepartures.fulfilled]: (state, {payload}) => {
            state.departures = payload.data.content;
            state.loadingTrips = false;
        },
        [fetchAllDepartures.rejected]: (state) => {
            state.loadingTrips = false;
        },
        [fetchAllDeparturesByOperator.pending]: (state) => {
            state.loadingTrips = true;
        },
        [fetchAllDeparturesByOperator.fulfilled]: (state, {payload}) => {
            state.departures = payload.data.content;
            state.loadingTrips = false;
        },
        [fetchAllDeparturesByOperator.rejected]: (state) => {
            state.loadingTrips = false;
        },
        [getAllTripTimesByOperator.pending]: (state) => {
            state.loadingTrips = true;
        },
        [getAllTripTimesByOperator.fulfilled]: (state, {payload}) => {
            const sortedTime = payload.data.sort((a, b) => moment(a, 'HH:mm:ss').diff(moment(b, 'HH:mm:ss')));
            state.tripTimes = sortedTime;
            state.loadingTrips = false;
        },
        [getAllTripTimesByOperator.rejected]: (state) => {
            state.loadingTrips = false;
        },
        [updateDeparture.pending]: (state) => {
            state.loadingTrips = true;
        },
        [updateDeparture.fulfilled]: (state, {payload}) => {
           const arr = [...current(state.departures)]
            const index = arr.findIndex(i => i.id === payload.data.id)
            if(index !== -1){
                arr[index] = payload.data;
                state.departures = arr;
            }
            state.loadingTrips = false;
        },
        [updateDeparture.rejected]: (state) => {
            state.loadingTrips = false;
        },
        [postDeparture.pending]: (state) => {
            state.loadingTrips = true;
        },
        [postDeparture.fulfilled]: (state, action) => {
            state.loadingTrips = false;
            let arr = state.departures
            arr.push(action.meta.arg)
            state.departures = arr
        },
        [postDeparture.rejected]: (state) => {
            state.loadingTrips = false;
        },
        [deleteDepartureById.pending]: (state) => {
            state.loadingTrips = true;
        },
        [deleteDepartureById.fulfilled]: (state, {payload}) => {
            state.loadingTrips = false;
            const arr = state.departures
            const index = arr.findIndex(i => i.id === payload.id)
            if(index !== -1){
                const obj = {...arr[index]}
                obj.status = false
                arr[index] = obj
            }
            state.departures = arr
        },
        [deleteDepartureById.rejected]: (state) => {
            state.loadingTrips = false;
        },
        [getDepartureById.pending]: (state) => {
            state.loadingTrips = true;
        },
        [getDepartureById.fulfilled]: (state, {payload}) => {
            state.loadingTrips = false;
            state.departures = payload.data.content;
        },
        [getDepartureById.rejected]: (state) => {
            state.loadingTrips = false;
        },
    }
});

export const departureReducer = departureSlice.reducer
